import service from "./service"

const preCheckCandidateView = async (payload) => {
    return service(payload)
}

export default preCheckCandidateView
